<script setup lang="ts">
import { onMounted,ref } from 'vue';
import { AccountClient } from '../api';
import TurnstileWidget from './TurnstileWidget.vue';
const props=defineProps<{client:AccountClient;action?:string}>();
const emit=defineEmits<{token:[value:string]}>();
const sitekey=ref(''),error=ref(''),widget=ref<InstanceType<typeof TurnstileWidget>>();
onMounted(async()=>{try{const state=await props.client.bootstrap();if(state.realm==='account')sitekey.value=state.turnstileSitekey||'';}catch{error.value='奴才该死！人机验证没能加载出来，还请吾皇再试一次！😭';}});
defineExpose({reset:()=>{emit('token','');widget.value?.reset();}});
</script>
<template><TurnstileWidget v-if="sitekey" ref="widget" :sitekey="sitekey" :action="action||'account-email'" @update:token="emit('token',$event)" @error="error='奴才惶恐！人机验证迟迟未能启动，还请吾皇刷新页面，再给奴才一次机会！🙇'" /><p v-if="error" class="inline-error">{{ error }}</p></template>
